import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { PropertyAmenityDescription, PropertyAmenityDescriptionSplitted, PropertyDetailedAmenities, PropertyDetailedAmenitiesSplitted } from '@shared-ui/lodging-property-details';
import { AccessibilityAttributes } from '@shared-ui/retail-product-accessibility-attributes';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { RefTarget } from '@shared-ui/ref-context';
import { PRODUCT_DETAILS_ACCESSIBILITY_BATCH_KEY } from 'constants/batchKeys';
import { IdentifierType } from '__generated__/api';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const AmenityDescriptionWrapper = ({
  inputs
}) => {
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  const Amenities = React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(Experiment, {
    name: "Detailed_Content_Amenities"
  }, React.createElement(ExperimentControl, null, React.createElement(PropertyAmenityDescription, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(PropertyDetailedAmenities, {
    inputs: inputs
  }))))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(Experiment, {
    name: "Detailed_Content_Amenities"
  }, React.createElement(ExperimentControl, null, React.createElement(PropertyAmenityDescriptionSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(PropertyDetailedAmenitiesSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))));
  return React.createElement(React.Fragment, null, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(Experiment, {
    name: "Remove_amenities_section_on_PDP_web"
  }, React.createElement(ExperimentControl, null, React.createElement(RefTarget, {
    name: "Amenities"
  }, Amenities)), React.createElement(ExperimentVariant, {
    bucket: 1
  }, Amenities), React.createElement(ExperimentVariant, {
    bucket: 2
  }, Amenities))), React.createElement(EGDSSpacing, null, React.createElement(RefTarget, {
    name: "Accessibility"
  }, React.createElement(Experiment, {
    name: "CID_Accessibility_Section_Breakout"
  }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(AccessibilityAttributes, {
    inputs: {
      productIdentifier: {
        id: inputs.propertyId,
        type: IdentifierType.PROPERTY_ID,
        travelSearchCriteria: {
          property: inputs.searchCriteria
        }
      }
    },
    batchKey: PRODUCT_DETAILS_ACCESSIBILITY_BATCH_KEY
  })))))));
};
export const SharedUiAmenityDescriptionWrapper = withSharedUiPropertyDetails(AmenityDescriptionWrapper);
SharedUiAmenityDescriptionWrapper.displayName = 'SharedUiAmenityDescriptionWrapper';